// extracted by mini-css-extract-plugin
export default {"container":"popupRefuse_container__hIeEV","content":"popupRefuse_content__ZltiQ","btns":"popupRefuse_btns__FBqjr","description":"popupRefuse_description__P0Q4I"};